@if(currentSection === 'fileUpload'){
  <main class="main">
    <h2>File upload</h2>
    <p class="description">Please choose a firmware file to create a firmware package.</p>
    @if(!processing() && !isLoading()){
      <div>
        @if(!isEditingFirmwarePackage()){
          <div
            class="file-upload-box"
            [class.error]="error"
            (dragover)="onDragOver($event)"
            (drop)="onDropSuccess($event)"
            [class.disabled]="files().length > 0">
            <div class="upload-icon">
              <img src="/svgs/file-upload.svg" alt="file" />
            </div>
            <div class="mt-050-rem">
              <input
                [disabled]="files().length > 0"
                #fileInput
                type="file"
                (change)="onChange($event)"
                hidden />

              <button
                mat-flat-button
                [disabled]="files().length > 0"
                color="primary"
                (click)="fileInput.click()">
                Choose files
              </button>
            </div>
            <div class="mt-050-rem">
              <p class="upload-text">or drag &amp; drop files here</p>
            </div>

            @if(error) {
              <div class="flex items-center text-label-sm-weight-regular gap-025-em text-feedback-fg-error mt-025-em">
                <i class="icon_marina_ui_CrossContainedOutlined text-feedback-fg-error text-[1rem]"></i>
                <span> {{ error }}</span>
              </div>
            }
          </div>
        } @else {
          <div class="flex space-x-050-em file-upload-box-editing">
            <div class="py-025-rem px-075-rem bg-action-bg-disabled text-action-fg-disabled rounded-150">
              Choose files
            </div>
            <p class="upload-text">or drag &amp; drop files here</p>
          </div>
        }

        @if (files().length > 0) {
          <div class="selected-files mt-075-rem max-w-132">
            @for (file of files(); track file; let i = $index) {
              <div
                class="flex items-center justify-between mx-200-rem"
                >
                <div class="flex items-center gap-075-rem">
                  <div>
                    <img src="/svgs/file-icon.svg" alt="file" />
                  </div>
                  <div class="flex flex-col">
                    <span class="truncate block max-w-50">{{ file.name }}</span>
                    <span class="text-gray-500">{{ file.size | number }} bytes</span>
                  </div>
                </div>
                <div>
                  @if (!isEditingFirmwarePackage()) {
                    <button
                      class="cursor-pointer"
                      type="button"
                      (click)="removeFile(i)"
                      aria-label="Remove file">
                      <img src="/svgs/delete-icon.svg" alt="file" />
                    </button>
                  }
                </div>
              </div>
            }
          </div>
        }
      </div>
      }@else {
      <div class="file-upload-box-loading-overlay">
        <div class="spinner"></div>
        <div class="loading-text">Loading...</div>
      </div>
    }
  </main>
}